import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53028)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1383 41.3792H0.862596C0.386523 41.3792 0.000488281 40.9932 0.000488281 40.5171V9.48271C0.000488281 9.00664 0.386523 8.62061 0.862596 8.62061H49.1384C49.6145 8.62061 50.0005 9.00664 50.0005 9.48271V40.5171C50.0004 40.9933 49.6144 41.3792 49.1383 41.3792Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.5521 13.2038L6.38264 24.2635C5.83079 24.5993 5.83079 25.4003 6.38264 25.7362L24.5521 36.796C24.8274 36.9635 25.1732 36.9635 25.4486 36.796L43.6182 25.7363C44.1701 25.4005 44.1701 24.5995 43.6182 24.2636L25.4486 13.2038C25.1733 13.0362 24.8274 13.0362 24.5521 13.2038Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0005 31.8965C28.8093 31.8965 31.8969 28.8088 31.8969 25C31.8969 21.1912 28.8093 18.1035 25.0005 18.1035C21.1917 18.1035 18.104 21.1912 18.104 25C18.104 28.8088 21.1917 31.8965 25.0005 31.8965Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.0825 21.4718C18.7571 22.0165 18.5059 22.6085 18.3398 23.2372C22.163 22.9495 27.8185 24.019 31.4181 27.5119C31.6531 26.9121 31.8082 26.2733 31.8664 25.6054C28.1495 22.4772 23.0109 21.3648 19.0825 21.4718Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.2859 27.3533L25.4695 27.9039L26.0499 27.9083C26.125 27.9089 26.1561 28.0048 26.0958 28.0495L25.6289 28.3943L25.804 28.9476C25.8266 29.0193 25.745 29.0786 25.6839 29.0348L25.2118 28.6973L24.7396 29.0348C24.6785 29.0786 24.5969 29.0193 24.6196 28.9476L24.7947 28.3943L24.3278 28.0495C24.2673 28.0048 24.2985 27.9089 24.3736 27.9083L24.954 27.9039L25.1376 27.3533C25.1613 27.282 25.2621 27.282 25.2859 27.3533Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.5415 28.7775L27.6205 29.0144L27.8703 29.0163C27.9027 29.0165 27.9161 29.0578 27.8901 29.0771L27.6891 29.2254L27.7644 29.4636C27.7742 29.4945 27.7391 29.5199 27.7127 29.5011L27.5095 29.3559L27.3063 29.5011C27.28 29.5199 27.2449 29.4945 27.2546 29.4636L27.3299 29.2254L27.1289 29.0771C27.103 29.0579 27.1163 29.0166 27.1487 29.0163L27.3985 29.0144L27.4775 28.7775C27.4878 28.7467 27.5313 28.7467 27.5415 28.7775Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.3106 26.3072L24.3896 26.5441L24.6394 26.546C24.6717 26.5462 24.6852 26.5875 24.6591 26.6068L24.4581 26.7551L24.5334 26.9933C24.5432 27.0242 24.5081 27.0497 24.4818 27.0308L24.2786 26.8856L24.0753 27.0308C24.0491 27.0497 24.0139 27.0242 24.0237 26.9933L24.099 26.7551L23.898 26.6068C23.872 26.5876 23.8854 26.5463 23.9177 26.546L24.1675 26.5441L24.2465 26.3072C24.2569 26.2765 24.3003 26.2765 24.3106 26.3072Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.9351 26.0201L20.0141 26.257L20.2639 26.2589C20.2962 26.2591 20.3097 26.3004 20.2836 26.3197L20.0827 26.468L20.1579 26.7062C20.1677 26.7371 20.1327 26.7625 20.1063 26.7437L19.9031 26.5985L19.6998 26.7437C19.6736 26.7625 19.6384 26.7371 19.6482 26.7062L19.7235 26.468L19.5225 26.3197C19.4965 26.3005 19.5099 26.2592 19.5422 26.2589L19.792 26.257L19.871 26.0201C19.8815 25.9894 19.9248 25.9894 19.9351 26.0201Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.5952 28.6958L23.6743 28.9327L23.9241 28.9346C23.9564 28.9348 23.9699 28.9761 23.9438 28.9954L23.7428 29.1437L23.8181 29.3819C23.8279 29.4128 23.7928 29.4383 23.7664 29.4194L23.5632 29.2742L23.36 29.4194C23.3337 29.4383 23.2986 29.4128 23.3083 29.3819L23.3836 29.1437L23.1827 28.9954C23.1567 28.9762 23.1701 28.9349 23.2024 28.9346L23.4522 28.9327L23.5312 28.6958C23.5416 28.6652 23.5851 28.6652 23.5952 28.6958Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.5814 25.8548L21.6461 26.0485L21.8504 26.0502C21.8767 26.0504 21.8878 26.0842 21.8666 26.0999L21.7022 26.2212L21.7638 26.4159C21.7718 26.4411 21.7431 26.462 21.7215 26.4466L21.5553 26.3278L21.3891 26.4466C21.3675 26.462 21.3389 26.4411 21.3468 26.4159L21.4085 26.2212L21.2441 26.0999C21.2229 26.0842 21.2338 26.0504 21.2603 26.0502L21.4646 26.0485L21.5293 25.8548C21.5376 25.8297 21.573 25.8297 21.5814 25.8548Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.7167 21.8546L27.7976 22.097L28.053 22.099C28.0861 22.0992 28.0998 22.1415 28.0731 22.1611L27.8677 22.3128L27.9447 22.5565C27.9548 22.588 27.9188 22.6141 27.8919 22.5949L27.684 22.4462L27.4761 22.5949C27.4491 22.6142 27.4133 22.5879 27.4232 22.5565L27.5003 22.3128L27.2948 22.1611C27.2682 22.1415 27.2819 22.0993 27.3149 22.099L27.5704 22.097L27.6513 21.8546C27.6618 21.8232 27.7063 21.8232 27.7167 21.8546Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.2162 24.6692L20.2808 24.863L20.4851 24.8646C20.5115 24.8648 20.5225 24.8986 20.5013 24.9143L20.337 25.0356L20.3986 25.2303C20.4066 25.2555 20.3779 25.2764 20.3563 25.261L20.1901 25.1423L20.0239 25.261C20.0023 25.2764 19.9737 25.2555 19.9816 25.2303L20.0432 25.0356L19.8789 24.9143C19.8577 24.8986 19.8685 24.8649 19.8951 24.8646L20.0994 24.863L20.164 24.6692C20.1723 24.6441 20.2078 24.6441 20.2162 24.6692Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.2027 27.4005L21.3006 27.694L21.61 27.6964C21.65 27.6967 21.6666 27.7478 21.6344 27.7716L21.3855 27.9554L21.4788 28.2503C21.4909 28.2885 21.4475 28.3201 21.4149 28.2968L21.1631 28.1169L20.9113 28.2968C20.8788 28.32 20.8353 28.2885 20.8474 28.2503L20.9407 27.9554L20.6918 27.7716C20.6596 27.7478 20.6762 27.6967 20.7162 27.6964L21.0256 27.694L21.1235 27.4005C21.1364 27.3626 21.1901 27.3626 21.2027 27.4005Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28.7994 28.8392L28.8609 29.0239L29.0556 29.0254C29.0808 29.0256 29.0912 29.0577 29.071 29.0726L28.9145 29.1883L28.9732 29.3738C28.9808 29.3978 28.9534 29.4177 28.9328 29.403L28.7745 29.2898L28.6161 29.403C28.5956 29.4177 28.5683 29.3978 28.5758 29.3738L28.6345 29.1883L28.4779 29.0726C28.4577 29.0577 28.4682 29.0256 28.4934 29.0254L28.688 29.0239L28.7495 28.8392C28.7576 28.8153 28.7915 28.8153 28.7994 28.8392Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M29.4805 27.4298L29.5595 27.6667L29.8093 27.6687C29.8416 27.6689 29.8551 27.7102 29.829 27.7294L29.6281 27.8778L29.7034 28.1159C29.7131 28.1468 29.6781 28.1723 29.6517 28.1534L29.4485 28.0082L29.2452 28.1534C29.219 28.1723 29.1838 28.1468 29.1936 28.1159L29.2689 27.8778L29.0679 27.7294C29.0419 27.7103 29.0553 27.669 29.0876 27.6687L29.3374 27.6667L29.4164 27.4298C29.4268 27.399 29.4702 27.399 29.4805 27.4298Z",
					fill: "#F3F3F3"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53028",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgBrFlag);
export { ForwardRef as ReactComponent };
